// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  CoachListCoachFragmentDoc,
  CoachListCategoryFragmentDoc,
  CoachListLelandPlusContributorCoachBatchResponseFragmentDoc,
  CoachListOfferingPackageFragmentDoc,
  CoachListSkuFragmentDoc,
} from './CoachList.generated';
import { SearchFiltersSchoolFragmentDoc } from './SearchFilters.generated';
import {
  OfferingPackagesSchoolFragmentDoc,
  OfferingPackagesSubCategoryFragmentDoc,
  OfferingPackagesCategoryFragmentDoc,
} from './OfferingPackages.generated';
import { UpcomingClassesCarouselCategoryFragmentDoc } from '../carousels/__generated-gql-types__/UpcomingClassesCarousel.generated';
import {
  CoachesSectionWithFilterCategoryFragmentDoc,
  CoachesSectionWithFilterLelandPlusContributorCoachBatchResponseFragmentDoc,
  CoachesSectionWithFilterSkuFragmentDoc,
} from './CoachesSectionWithFilters.generated';
import { BootcampCardBootcampFragmentDoc } from '../../bootcamps/__generated-gql-types__/BootcampCard.generated';
import { CoachesTabsCoachFragmentDoc } from '../../category/__generated-gql-types__/CoachesTabs.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CategoryLevelPageCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  tier: Types.SkuTier;
  bio?: string | null;
  hourlyRate?: number | null;
  reviewTotal: number;
  averageReviewRate: number;
  isSuperCoach?: boolean | null;
  totalCoachingMinutes: number;
  isSaved?: boolean | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    headline?: string | null;
    testScore?: number | null;
    qualifications?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      name: string;
      goal: Types.GoalName;
    };
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  educationExperiences?: Array<{
    __typename?: 'Education';
    admissionCommittee: boolean;
    isFeatured?: boolean | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  professionalExperiences?: Array<{
    __typename?: 'ProfessionalExperience';
    experienceType?: Types.ExperienceType | null;
    isFeatured?: boolean | null;
    company: {
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    };
    endAt?: { __typename?: 'MonthYear'; year: number } | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'TestOutcomeSummary';
        scoreRange?: string | null;
        category: { __typename?: 'Category'; id: string };
      }
  > | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  schoolAdmissionInfoList?: Array<{
    __typename?: 'SchoolAdmissionInfo';
    status?: Types.SchoolAdmissionStatus | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  companiesAdmitted?: Array<{
    __typename?: 'Company';
    id?: string | null;
    name: string;
    domain?: string | null;
    logoLink?: string | null;
  }> | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
};

export type CategoryLevelPageSchoolFragment = {
  __typename?: 'School';
  id: string;
  name: string;
  logoLink?: string | null;
};

export type CategoryLevelPageSubCategoryFragment = {
  __typename?: 'SubCategory';
  id: string;
  name: string;
  slug: string;
  v2Urn: string;
};

export type CategoryLevelPageCategoryFragment = {
  __typename?: 'Category';
  id: string;
  name: string;
  slug: string;
  goal: Types.GoalName;
  shouldShowSubCategories?: boolean | null;
  subCategoryTitle?: string | null;
  srpTitle?: string | null;
  relatedCategories?: Array<{ __typename?: 'Category'; id: string }> | null;
  subCategoryList?: Array<{
    __typename?: 'SubCategory';
    id: string;
    slug: string;
    v2Urn: string;
    name: string;
  }> | null;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
    description?: string | null;
    libraryPath?: string | null;
  }> | null;
  comprehensiveFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
  featuredFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
};

export type CategoryLevelPageLelandPlusContributorCoachBatchResponseFragment = {
  __typename?: 'CoachBatchResponse';
  total: number;
  results: Array<{
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  }>;
};

export type CategoryLevelPageSkuFragment = {
  __typename?: 'Sku';
  id: string;
  tier: Types.SkuTier;
  unitPrice: number;
};

export type CategoryLevelPageBootcampFragment = {
  __typename?: 'Bootcamp';
  id: string;
  title: string;
  description: string;
  landingPageUrl: string;
  slug: string;
  imageLink: string;
  headline: string;
  maximumAttendees?: number | null;
  reviewRate?: number | null;
  reviewCount?: number | null;
  curriculums: Array<{
    __typename?: 'BootcampCurriculum';
    title: string;
    description: string;
  }>;
  cohorts: Array<{
    __typename?: 'BootcampCohort';
    totalAttendees: number;
    sessions: Array<{
      __typename?: 'CoachingSession';
      id: string;
      startAt: number;
    }>;
  }>;
  coaches: Array<{
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  }>;
};

export type CategoryLevelPageBookedCoachesQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CategoryLevelPageBookedCoachesQuery = {
  __typename?: 'Query';
  bookedCoaches: {
    __typename?: 'CoachBatchResponse';
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      bio?: string | null;
      hourlyRate?: number | null;
      reviewTotal: number;
      averageReviewRate: number;
      isSaved?: boolean | null;
      couldScheduleIntro?: boolean | null;
      everHadCoachingSessionWithCoach?: boolean | null;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        id: string;
        category: {
          __typename?: 'Category';
          id: string;
          goal: Types.GoalName;
          sortRank?: number | null;
          slug: string;
          name: string;
        };
      }> | null;
      educationExperiences?: Array<{
        __typename?: 'Education';
        admissionCommittee: boolean;
        isFeatured?: boolean | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      professionalExperiences?: Array<{
        __typename?: 'ProfessionalExperience';
        experienceType?: Types.ExperienceType | null;
        isFeatured?: boolean | null;
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          domain?: string | null;
          logoLink?: string | null;
        };
        endAt?: { __typename?: 'MonthYear'; year: number } | null;
      }> | null;
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
      } | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        paidTimeInMinute?: number | null;
        customerSubscription?: {
          __typename?: 'CustomerSubscription';
          id: string;
          sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
        } | null;
      } | null;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'TestOutcomeSummary';
            scoreRange?: string | null;
            category: { __typename?: 'Category'; id: string };
          }
      > | null;
      coachingTimeSummary?: {
        __typename?: 'CoachingTimeSummary';
        availableTime: number;
        hasUnlimitedPackage: boolean;
        cycles?: Array<{
          __typename?: 'SubscriptionCycle';
          timeInMinute: number;
          start?: number | null;
          end?: number | null;
        }> | null;
      } | null;
    }>;
  };
};

export type CategoryLevelPageSearchCoachesTotalQueryVariables = Types.Exact<{
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
  subCategoryListFilter?: Types.InputMaybe<
    | Array<Types.Scalars['SubCategoryUrn']['input']>
    | Types.Scalars['SubCategoryUrn']['input']
  >;
}>;

export type CategoryLevelPageSearchCoachesTotalQuery = {
  __typename?: 'Query';
  searchCoaches: { __typename?: 'CoachSearchResponse'; total: number };
};

export type CategoryLevelPageSearchCoachesQueryVariables = Types.Exact<{
  keyword?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
  coachingFocusListFilter?: Types.InputMaybe<
    | Array<Types.Scalars['CoachingFocusUrn']['input']>
    | Types.Scalars['CoachingFocusUrn']['input']
  >;
  hourlyRateFilter?: Types.InputMaybe<Types.IntRangeInput>;
  hasAdmissionCommitteeFilter?: Types.InputMaybe<
    Types.Scalars['Boolean']['input']
  >;
  schoolsFilter?: Types.InputMaybe<
    | Array<Types.Scalars['SchoolUrn']['input']>
    | Types.Scalars['SchoolUrn']['input']
  >;
  companyFilter?: Types.InputMaybe<
    | Array<Types.Scalars['CompanyUrn']['input']>
    | Types.Scalars['CompanyUrn']['input']
  >;
  subCategoryListFilter?: Types.InputMaybe<
    | Array<Types.Scalars['SubCategoryUrn']['input']>
    | Types.Scalars['SubCategoryUrn']['input']
  >;
  hasInternationalServiceFilter?: Types.InputMaybe<
    Types.Scalars['Boolean']['input']
  >;
  professionalCoachFilter?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  specialBackgroundsFilter?: Types.InputMaybe<
    Array<Types.SpecialBackground> | Types.SpecialBackground
  >;
  skuTiers?: Types.InputMaybe<Array<Types.SkuTier> | Types.SkuTier>;
  sortBy?: Types.InputMaybe<Types.CoachSortBy>;
  sortOrder?: Types.InputMaybe<Types.SortOrder>;
  offset: Types.Scalars['Int']['input'];
  count: Types.Scalars['Int']['input'];
}>;

export type CategoryLevelPageSearchCoachesQuery = {
  __typename?: 'Query';
  searchCoaches: {
    __typename?: 'CoachSearchResponse';
    total: number;
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      bio?: string | null;
      hourlyRate?: number | null;
      reviewTotal: number;
      averageReviewRate: number;
      isSuperCoach?: boolean | null;
      totalCoachingMinutes: number;
      isSaved?: boolean | null;
      couldScheduleIntro?: boolean | null;
      everHadCoachingSessionWithCoach?: boolean | null;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        id: string;
        headline?: string | null;
        testScore?: number | null;
        qualifications?: string | null;
        category: {
          __typename?: 'Category';
          id: string;
          slug: string;
          name: string;
          goal: Types.GoalName;
        };
      }> | null;
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
      } | null;
      educationExperiences?: Array<{
        __typename?: 'Education';
        admissionCommittee: boolean;
        isFeatured?: boolean | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      professionalExperiences?: Array<{
        __typename?: 'ProfessionalExperience';
        experienceType?: Types.ExperienceType | null;
        isFeatured?: boolean | null;
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          domain?: string | null;
          logoLink?: string | null;
        };
        endAt?: { __typename?: 'MonthYear'; year: number } | null;
      }> | null;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'TestOutcomeSummary';
            scoreRange?: string | null;
            category: { __typename?: 'Category'; id: string };
          }
      > | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        paidTimeInMinute?: number | null;
        customerSubscription?: {
          __typename?: 'CustomerSubscription';
          id: string;
          sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
        } | null;
      } | null;
      schoolAdmissionInfoList?: Array<{
        __typename?: 'SchoolAdmissionInfo';
        status?: Types.SchoolAdmissionStatus | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      companiesAdmitted?: Array<{
        __typename?: 'Company';
        id?: string | null;
        name: string;
        domain?: string | null;
        logoLink?: string | null;
      }> | null;
      coachingTimeSummary?: {
        __typename?: 'CoachingTimeSummary';
        availableTime: number;
        hasUnlimitedPackage: boolean;
        cycles?: Array<{
          __typename?: 'SubscriptionCycle';
          timeInMinute: number;
          start?: number | null;
          end?: number | null;
        }> | null;
      } | null;
    }>;
  };
};

export type CategoryLevelPageCategoryBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type CategoryLevelPageCategoryBySlugQuery = {
  __typename?: 'Query';
  categoryBySlug: {
    __typename?: 'Category';
    id: string;
    name: string;
    slug: string;
    goal: Types.GoalName;
    shouldShowSubCategories?: boolean | null;
    subCategoryTitle?: string | null;
    srpTitle?: string | null;
    relatedCategories?: Array<{ __typename?: 'Category'; id: string }> | null;
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      id: string;
      slug: string;
      v2Urn: string;
      name: string;
    }> | null;
    coachingFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
      description?: string | null;
      libraryPath?: string | null;
    }> | null;
    comprehensiveFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
    }> | null;
    featuredFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
    }> | null;
  };
};

export type CategoryLevelPageGetActiveCategoriesQueryVariables = Types.Exact<{
  count: Types.Scalars['Int']['input'];
}>;

export type CategoryLevelPageGetActiveCategoriesQuery = {
  __typename?: 'Query';
  searchCategories: {
    __typename?: 'CategoryBatchResponse';
    results: Array<{
      __typename?: 'Category';
      id: string;
      slug: string;
      goal: Types.GoalName;
      shouldShowSubCategories?: boolean | null;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        slug: string;
        v2Urn: string;
      }> | null;
    }>;
  };
};

export type CategoryLevelPageUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CategoryLevelPageUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    applicant?: {
      __typename?: 'Applicant';
      hasLelandPlusAccess?: boolean | null;
    } | null;
  } | null;
};

export type CategoryLevelPageLelandPlusContributorsQueryVariables =
  Types.Exact<{
    categoryUrn: Types.Scalars['CategoryUrn']['input'];
  }>;

export type CategoryLevelPageLelandPlusContributorsQuery = {
  __typename?: 'Query';
  lelandPlusContributors: {
    __typename?: 'CoachBatchResponse';
    total: number;
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
    }>;
  };
};

export type CategoryLevelPageCoachesBySlugsQueryVariables = Types.Exact<{
  slugs:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input'];
}>;

export type CategoryLevelPageCoachesBySlugsQuery = {
  __typename?: 'Query';
  coachesBySlugs: Array<{
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  }>;
};

export type CategoryLevelPageSearchBootcampsQueryVariables = Types.Exact<{
  categoriesFilter?: Types.InputMaybe<
    | Array<Types.Scalars['CategoryUrn']['input']>
    | Types.Scalars['CategoryUrn']['input']
  >;
  subCategoriesFilter?: Types.InputMaybe<
    | Array<Types.Scalars['SubCategoryUrn']['input']>
    | Types.Scalars['SubCategoryUrn']['input']
  >;
  startDate?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;

export type CategoryLevelPageSearchBootcampsQuery = {
  __typename?: 'Query';
  searchBootcamps: {
    __typename?: 'BootcampBatchResponse';
    results: Array<{
      __typename?: 'Bootcamp';
      id: string;
      title: string;
      description: string;
      landingPageUrl: string;
      slug: string;
      imageLink: string;
      headline: string;
      maximumAttendees?: number | null;
      reviewRate?: number | null;
      reviewCount?: number | null;
      curriculums: Array<{
        __typename?: 'BootcampCurriculum';
        title: string;
        description: string;
      }>;
      cohorts: Array<{
        __typename?: 'BootcampCohort';
        totalAttendees: number;
        sessions: Array<{
          __typename?: 'CoachingSession';
          id: string;
          startAt: number;
        }>;
      }>;
      coaches: Array<{
        __typename?: 'Coach';
        id: string;
        slug: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
        };
      }>;
    }>;
  };
};

export type CategoryLevelPageStaticLexQueryVariables = Types.Exact<{
  slugs:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input'];
}>;

export type CategoryLevelPageStaticLexQuery = {
  __typename?: 'Query';
  lexListBySlugs: Array<{ __typename?: 'Lex'; isRamped: boolean }>;
};

export const CategoryLevelPageCoachFragmentDoc = gql`
  fragment CategoryLevelPage_Coach on Coach {
    ...CoachList_Coach
  }
  ${CoachListCoachFragmentDoc}
`;
export const CategoryLevelPageSchoolFragmentDoc = gql`
  fragment CategoryLevelPage_School on School {
    ...SearchFilters_School
    ...OfferingPackages_School
  }
  ${SearchFiltersSchoolFragmentDoc}
  ${OfferingPackagesSchoolFragmentDoc}
`;
export const CategoryLevelPageSubCategoryFragmentDoc = gql`
  fragment CategoryLevelPage_SubCategory on SubCategory {
    id
    name
    slug
    v2Urn
    ...OfferingPackages_SubCategory
  }
  ${OfferingPackagesSubCategoryFragmentDoc}
`;
export const CategoryLevelPageCategoryFragmentDoc = gql`
  fragment CategoryLevelPage_Category on Category {
    id
    name
    slug
    goal
    shouldShowSubCategories
    subCategoryTitle
    srpTitle
    relatedCategories {
      id
    }
    subCategoryList {
      ...CategoryLevelPage_SubCategory
    }
    ...UpcomingClassesCarousel_Category
    ...OfferingPackages_Category
    ...CoachesSectionWithFilter_Category
  }
  ${CategoryLevelPageSubCategoryFragmentDoc}
  ${UpcomingClassesCarouselCategoryFragmentDoc}
  ${OfferingPackagesCategoryFragmentDoc}
  ${CoachesSectionWithFilterCategoryFragmentDoc}
`;
export const CategoryLevelPageLelandPlusContributorCoachBatchResponseFragmentDoc = gql`
  fragment CategoryLevelPageLelandPlusContributor_CoachBatchResponse on CoachBatchResponse {
    ...CoachesSectionWithFilterLelandPlusContributor_CoachBatchResponse
  }
  ${CoachesSectionWithFilterLelandPlusContributorCoachBatchResponseFragmentDoc}
`;
export const CategoryLevelPageSkuFragmentDoc = gql`
  fragment CategoryLevelPage_Sku on Sku {
    ...CoachesSectionWithFilter_Sku
  }
  ${CoachesSectionWithFilterSkuFragmentDoc}
`;
export const CategoryLevelPageBootcampFragmentDoc = gql`
  fragment CategoryLevelPage_Bootcamp on Bootcamp {
    id
    title
    description
    landingPageUrl
    ...BootcampCard_Bootcamp
  }
  ${BootcampCardBootcampFragmentDoc}
`;
export const CategoryLevelPageBookedCoachesDocument = gql`
  query CategoryLevelPage_BookedCoaches {
    bookedCoaches(count: 20) {
      results {
        ...CoachesTabs_Coach
      }
    }
  }
  ${CoachesTabsCoachFragmentDoc}
`;

/**
 * __useCategoryLevelPageBookedCoachesQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageBookedCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageBookedCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageBookedCoachesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryLevelPageBookedCoachesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CategoryLevelPageBookedCoachesQuery,
    CategoryLevelPageBookedCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageBookedCoachesQuery,
    CategoryLevelPageBookedCoachesQueryVariables
  >(CategoryLevelPageBookedCoachesDocument, options);
}
export function useCategoryLevelPageBookedCoachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageBookedCoachesQuery,
    CategoryLevelPageBookedCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageBookedCoachesQuery,
    CategoryLevelPageBookedCoachesQueryVariables
  >(CategoryLevelPageBookedCoachesDocument, options);
}
export function useCategoryLevelPageBookedCoachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageBookedCoachesQuery,
        CategoryLevelPageBookedCoachesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageBookedCoachesQuery,
    CategoryLevelPageBookedCoachesQueryVariables
  >(CategoryLevelPageBookedCoachesDocument, options);
}
export type CategoryLevelPageBookedCoachesQueryHookResult = ReturnType<
  typeof useCategoryLevelPageBookedCoachesQuery
>;
export type CategoryLevelPageBookedCoachesLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageBookedCoachesLazyQuery
>;
export type CategoryLevelPageBookedCoachesSuspenseQueryHookResult = ReturnType<
  typeof useCategoryLevelPageBookedCoachesSuspenseQuery
>;
export type CategoryLevelPageBookedCoachesQueryResult = Apollo.QueryResult<
  CategoryLevelPageBookedCoachesQuery,
  CategoryLevelPageBookedCoachesQueryVariables
>;
export const CategoryLevelPageSearchCoachesTotalDocument = gql`
  query CategoryLevelPage_SearchCoachesTotal(
    $categoryUrn: CategoryUrn
    $subCategoryListFilter: [SubCategoryUrn!]
  ) {
    searchCoaches(
      categoryUrn: $categoryUrn
      subCategoryListFilter: $subCategoryListFilter
    ) {
      total
    }
  }
`;

/**
 * __useCategoryLevelPageSearchCoachesTotalQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageSearchCoachesTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageSearchCoachesTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageSearchCoachesTotalQuery({
 *   variables: {
 *      categoryUrn: // value for 'categoryUrn'
 *      subCategoryListFilter: // value for 'subCategoryListFilter'
 *   },
 * });
 */
export function useCategoryLevelPageSearchCoachesTotalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CategoryLevelPageSearchCoachesTotalQuery,
    CategoryLevelPageSearchCoachesTotalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageSearchCoachesTotalQuery,
    CategoryLevelPageSearchCoachesTotalQueryVariables
  >(CategoryLevelPageSearchCoachesTotalDocument, options);
}
export function useCategoryLevelPageSearchCoachesTotalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageSearchCoachesTotalQuery,
    CategoryLevelPageSearchCoachesTotalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageSearchCoachesTotalQuery,
    CategoryLevelPageSearchCoachesTotalQueryVariables
  >(CategoryLevelPageSearchCoachesTotalDocument, options);
}
export function useCategoryLevelPageSearchCoachesTotalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageSearchCoachesTotalQuery,
        CategoryLevelPageSearchCoachesTotalQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageSearchCoachesTotalQuery,
    CategoryLevelPageSearchCoachesTotalQueryVariables
  >(CategoryLevelPageSearchCoachesTotalDocument, options);
}
export type CategoryLevelPageSearchCoachesTotalQueryHookResult = ReturnType<
  typeof useCategoryLevelPageSearchCoachesTotalQuery
>;
export type CategoryLevelPageSearchCoachesTotalLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageSearchCoachesTotalLazyQuery
>;
export type CategoryLevelPageSearchCoachesTotalSuspenseQueryHookResult =
  ReturnType<typeof useCategoryLevelPageSearchCoachesTotalSuspenseQuery>;
export type CategoryLevelPageSearchCoachesTotalQueryResult = Apollo.QueryResult<
  CategoryLevelPageSearchCoachesTotalQuery,
  CategoryLevelPageSearchCoachesTotalQueryVariables
>;
export const CategoryLevelPageSearchCoachesDocument = gql`
  query CategoryLevelPage_SearchCoaches(
    $keyword: String
    $categoryUrn: CategoryUrn
    $coachingFocusListFilter: [CoachingFocusUrn!]
    $hourlyRateFilter: IntRangeInput
    $hasAdmissionCommitteeFilter: Boolean
    $schoolsFilter: [SchoolUrn!]
    $companyFilter: [CompanyUrn!]
    $subCategoryListFilter: [SubCategoryUrn!]
    $hasInternationalServiceFilter: Boolean
    $professionalCoachFilter: Boolean
    $specialBackgroundsFilter: [SpecialBackground!]
    $skuTiers: [SkuTier!]
    $sortBy: CoachSortBy
    $sortOrder: SortOrder
    $offset: Int!
    $count: Int!
  ) {
    searchCoaches(
      categoryUrn: $categoryUrn
      keyword: $keyword
      coachingFocusListFilter: $coachingFocusListFilter
      hourlyRateFilter: $hourlyRateFilter
      hasAdmissionCommitteeFilter: $hasAdmissionCommitteeFilter
      schoolsFilter: $schoolsFilter
      companyFilter: $companyFilter
      subCategoryListFilter: $subCategoryListFilter
      hasInternationalServiceFilter: $hasInternationalServiceFilter
      professionalCoachFilter: $professionalCoachFilter
      specialBackgroundsFilter: $specialBackgroundsFilter
      skuTiers: $skuTiers
      sortBy: $sortBy
      sortOrder: $sortOrder
      start: $offset
      count: $count
    ) {
      results {
        ...CategoryLevelPage_Coach
      }
      total
    }
  }
  ${CategoryLevelPageCoachFragmentDoc}
`;

/**
 * __useCategoryLevelPageSearchCoachesQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageSearchCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageSearchCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageSearchCoachesQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      categoryUrn: // value for 'categoryUrn'
 *      coachingFocusListFilter: // value for 'coachingFocusListFilter'
 *      hourlyRateFilter: // value for 'hourlyRateFilter'
 *      hasAdmissionCommitteeFilter: // value for 'hasAdmissionCommitteeFilter'
 *      schoolsFilter: // value for 'schoolsFilter'
 *      companyFilter: // value for 'companyFilter'
 *      subCategoryListFilter: // value for 'subCategoryListFilter'
 *      hasInternationalServiceFilter: // value for 'hasInternationalServiceFilter'
 *      professionalCoachFilter: // value for 'professionalCoachFilter'
 *      specialBackgroundsFilter: // value for 'specialBackgroundsFilter'
 *      skuTiers: // value for 'skuTiers'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      offset: // value for 'offset'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useCategoryLevelPageSearchCoachesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryLevelPageSearchCoachesQuery,
    CategoryLevelPageSearchCoachesQueryVariables
  > &
    (
      | {
          variables: CategoryLevelPageSearchCoachesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageSearchCoachesQuery,
    CategoryLevelPageSearchCoachesQueryVariables
  >(CategoryLevelPageSearchCoachesDocument, options);
}
export function useCategoryLevelPageSearchCoachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageSearchCoachesQuery,
    CategoryLevelPageSearchCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageSearchCoachesQuery,
    CategoryLevelPageSearchCoachesQueryVariables
  >(CategoryLevelPageSearchCoachesDocument, options);
}
export function useCategoryLevelPageSearchCoachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageSearchCoachesQuery,
        CategoryLevelPageSearchCoachesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageSearchCoachesQuery,
    CategoryLevelPageSearchCoachesQueryVariables
  >(CategoryLevelPageSearchCoachesDocument, options);
}
export type CategoryLevelPageSearchCoachesQueryHookResult = ReturnType<
  typeof useCategoryLevelPageSearchCoachesQuery
>;
export type CategoryLevelPageSearchCoachesLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageSearchCoachesLazyQuery
>;
export type CategoryLevelPageSearchCoachesSuspenseQueryHookResult = ReturnType<
  typeof useCategoryLevelPageSearchCoachesSuspenseQuery
>;
export type CategoryLevelPageSearchCoachesQueryResult = Apollo.QueryResult<
  CategoryLevelPageSearchCoachesQuery,
  CategoryLevelPageSearchCoachesQueryVariables
>;
export const CategoryLevelPageCategoryBySlugDocument = gql`
  query CategoryLevelPage_CategoryBySlug($slug: String!) {
    categoryBySlug(slug: $slug) {
      ...CategoryLevelPage_Category
    }
  }
  ${CategoryLevelPageCategoryFragmentDoc}
`;

/**
 * __useCategoryLevelPageCategoryBySlugQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageCategoryBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageCategoryBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageCategoryBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCategoryLevelPageCategoryBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryLevelPageCategoryBySlugQuery,
    CategoryLevelPageCategoryBySlugQueryVariables
  > &
    (
      | {
          variables: CategoryLevelPageCategoryBySlugQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageCategoryBySlugQuery,
    CategoryLevelPageCategoryBySlugQueryVariables
  >(CategoryLevelPageCategoryBySlugDocument, options);
}
export function useCategoryLevelPageCategoryBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageCategoryBySlugQuery,
    CategoryLevelPageCategoryBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageCategoryBySlugQuery,
    CategoryLevelPageCategoryBySlugQueryVariables
  >(CategoryLevelPageCategoryBySlugDocument, options);
}
export function useCategoryLevelPageCategoryBySlugSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageCategoryBySlugQuery,
        CategoryLevelPageCategoryBySlugQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageCategoryBySlugQuery,
    CategoryLevelPageCategoryBySlugQueryVariables
  >(CategoryLevelPageCategoryBySlugDocument, options);
}
export type CategoryLevelPageCategoryBySlugQueryHookResult = ReturnType<
  typeof useCategoryLevelPageCategoryBySlugQuery
>;
export type CategoryLevelPageCategoryBySlugLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageCategoryBySlugLazyQuery
>;
export type CategoryLevelPageCategoryBySlugSuspenseQueryHookResult = ReturnType<
  typeof useCategoryLevelPageCategoryBySlugSuspenseQuery
>;
export type CategoryLevelPageCategoryBySlugQueryResult = Apollo.QueryResult<
  CategoryLevelPageCategoryBySlugQuery,
  CategoryLevelPageCategoryBySlugQueryVariables
>;
export const CategoryLevelPageGetActiveCategoriesDocument = gql`
  query CategoryLevelPage_GetActiveCategories($count: Int!) {
    searchCategories(activeCoachFilter: true, count: $count) {
      results {
        id
        slug
        goal
        shouldShowSubCategories
        subCategoryList {
          id
          slug
          v2Urn
        }
      }
    }
  }
`;

/**
 * __useCategoryLevelPageGetActiveCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageGetActiveCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageGetActiveCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageGetActiveCategoriesQuery({
 *   variables: {
 *      count: // value for 'count'
 *   },
 * });
 */
export function useCategoryLevelPageGetActiveCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryLevelPageGetActiveCategoriesQuery,
    CategoryLevelPageGetActiveCategoriesQueryVariables
  > &
    (
      | {
          variables: CategoryLevelPageGetActiveCategoriesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageGetActiveCategoriesQuery,
    CategoryLevelPageGetActiveCategoriesQueryVariables
  >(CategoryLevelPageGetActiveCategoriesDocument, options);
}
export function useCategoryLevelPageGetActiveCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageGetActiveCategoriesQuery,
    CategoryLevelPageGetActiveCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageGetActiveCategoriesQuery,
    CategoryLevelPageGetActiveCategoriesQueryVariables
  >(CategoryLevelPageGetActiveCategoriesDocument, options);
}
export function useCategoryLevelPageGetActiveCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageGetActiveCategoriesQuery,
        CategoryLevelPageGetActiveCategoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageGetActiveCategoriesQuery,
    CategoryLevelPageGetActiveCategoriesQueryVariables
  >(CategoryLevelPageGetActiveCategoriesDocument, options);
}
export type CategoryLevelPageGetActiveCategoriesQueryHookResult = ReturnType<
  typeof useCategoryLevelPageGetActiveCategoriesQuery
>;
export type CategoryLevelPageGetActiveCategoriesLazyQueryHookResult =
  ReturnType<typeof useCategoryLevelPageGetActiveCategoriesLazyQuery>;
export type CategoryLevelPageGetActiveCategoriesSuspenseQueryHookResult =
  ReturnType<typeof useCategoryLevelPageGetActiveCategoriesSuspenseQuery>;
export type CategoryLevelPageGetActiveCategoriesQueryResult =
  Apollo.QueryResult<
    CategoryLevelPageGetActiveCategoriesQuery,
    CategoryLevelPageGetActiveCategoriesQueryVariables
  >;
export const CategoryLevelPageUserDocument = gql`
  query CategoryLevelPage_User {
    user {
      applicant {
        hasLelandPlusAccess
      }
    }
  }
`;

/**
 * __useCategoryLevelPageUserQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryLevelPageUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CategoryLevelPageUserQuery,
    CategoryLevelPageUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageUserQuery,
    CategoryLevelPageUserQueryVariables
  >(CategoryLevelPageUserDocument, options);
}
export function useCategoryLevelPageUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageUserQuery,
    CategoryLevelPageUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageUserQuery,
    CategoryLevelPageUserQueryVariables
  >(CategoryLevelPageUserDocument, options);
}
export function useCategoryLevelPageUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageUserQuery,
        CategoryLevelPageUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageUserQuery,
    CategoryLevelPageUserQueryVariables
  >(CategoryLevelPageUserDocument, options);
}
export type CategoryLevelPageUserQueryHookResult = ReturnType<
  typeof useCategoryLevelPageUserQuery
>;
export type CategoryLevelPageUserLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageUserLazyQuery
>;
export type CategoryLevelPageUserSuspenseQueryHookResult = ReturnType<
  typeof useCategoryLevelPageUserSuspenseQuery
>;
export type CategoryLevelPageUserQueryResult = Apollo.QueryResult<
  CategoryLevelPageUserQuery,
  CategoryLevelPageUserQueryVariables
>;
export const CategoryLevelPageLelandPlusContributorsDocument = gql`
  query CategoryLevelPage_LelandPlusContributors($categoryUrn: CategoryUrn!) {
    lelandPlusContributors(category: $categoryUrn) {
      ...CategoryLevelPageLelandPlusContributor_CoachBatchResponse
    }
  }
  ${CategoryLevelPageLelandPlusContributorCoachBatchResponseFragmentDoc}
`;

/**
 * __useCategoryLevelPageLelandPlusContributorsQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageLelandPlusContributorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageLelandPlusContributorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageLelandPlusContributorsQuery({
 *   variables: {
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useCategoryLevelPageLelandPlusContributorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryLevelPageLelandPlusContributorsQuery,
    CategoryLevelPageLelandPlusContributorsQueryVariables
  > &
    (
      | {
          variables: CategoryLevelPageLelandPlusContributorsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageLelandPlusContributorsQuery,
    CategoryLevelPageLelandPlusContributorsQueryVariables
  >(CategoryLevelPageLelandPlusContributorsDocument, options);
}
export function useCategoryLevelPageLelandPlusContributorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageLelandPlusContributorsQuery,
    CategoryLevelPageLelandPlusContributorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageLelandPlusContributorsQuery,
    CategoryLevelPageLelandPlusContributorsQueryVariables
  >(CategoryLevelPageLelandPlusContributorsDocument, options);
}
export function useCategoryLevelPageLelandPlusContributorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageLelandPlusContributorsQuery,
        CategoryLevelPageLelandPlusContributorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageLelandPlusContributorsQuery,
    CategoryLevelPageLelandPlusContributorsQueryVariables
  >(CategoryLevelPageLelandPlusContributorsDocument, options);
}
export type CategoryLevelPageLelandPlusContributorsQueryHookResult = ReturnType<
  typeof useCategoryLevelPageLelandPlusContributorsQuery
>;
export type CategoryLevelPageLelandPlusContributorsLazyQueryHookResult =
  ReturnType<typeof useCategoryLevelPageLelandPlusContributorsLazyQuery>;
export type CategoryLevelPageLelandPlusContributorsSuspenseQueryHookResult =
  ReturnType<typeof useCategoryLevelPageLelandPlusContributorsSuspenseQuery>;
export type CategoryLevelPageLelandPlusContributorsQueryResult =
  Apollo.QueryResult<
    CategoryLevelPageLelandPlusContributorsQuery,
    CategoryLevelPageLelandPlusContributorsQueryVariables
  >;
export const CategoryLevelPageCoachesBySlugsDocument = gql`
  query CategoryLevelPage_CoachesBySlugs($slugs: [String!]!) {
    coachesBySlugs(slugs: $slugs) {
      id
      user {
        id
        firstName
        lastName
        pictureLink
      }
      slug
    }
  }
`;

/**
 * __useCategoryLevelPageCoachesBySlugsQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageCoachesBySlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageCoachesBySlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageCoachesBySlugsQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useCategoryLevelPageCoachesBySlugsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryLevelPageCoachesBySlugsQuery,
    CategoryLevelPageCoachesBySlugsQueryVariables
  > &
    (
      | {
          variables: CategoryLevelPageCoachesBySlugsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageCoachesBySlugsQuery,
    CategoryLevelPageCoachesBySlugsQueryVariables
  >(CategoryLevelPageCoachesBySlugsDocument, options);
}
export function useCategoryLevelPageCoachesBySlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageCoachesBySlugsQuery,
    CategoryLevelPageCoachesBySlugsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageCoachesBySlugsQuery,
    CategoryLevelPageCoachesBySlugsQueryVariables
  >(CategoryLevelPageCoachesBySlugsDocument, options);
}
export function useCategoryLevelPageCoachesBySlugsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageCoachesBySlugsQuery,
        CategoryLevelPageCoachesBySlugsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageCoachesBySlugsQuery,
    CategoryLevelPageCoachesBySlugsQueryVariables
  >(CategoryLevelPageCoachesBySlugsDocument, options);
}
export type CategoryLevelPageCoachesBySlugsQueryHookResult = ReturnType<
  typeof useCategoryLevelPageCoachesBySlugsQuery
>;
export type CategoryLevelPageCoachesBySlugsLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageCoachesBySlugsLazyQuery
>;
export type CategoryLevelPageCoachesBySlugsSuspenseQueryHookResult = ReturnType<
  typeof useCategoryLevelPageCoachesBySlugsSuspenseQuery
>;
export type CategoryLevelPageCoachesBySlugsQueryResult = Apollo.QueryResult<
  CategoryLevelPageCoachesBySlugsQuery,
  CategoryLevelPageCoachesBySlugsQueryVariables
>;
export const CategoryLevelPageSearchBootcampsDocument = gql`
  query CategoryLevelPage_SearchBootcamps(
    $categoriesFilter: [CategoryUrn!]
    $subCategoriesFilter: [SubCategoryUrn!]
    $startDate: Long
  ) {
    searchBootcamps(
      categoriesFilter: $categoriesFilter
      subCategoriesFilter: $subCategoriesFilter
      startDate: $startDate
      includeRelatedCategories: true
      includeEmptyCohorts: true
      status: LIVE
      count: 2
    ) {
      results {
        ...CategoryLevelPage_Bootcamp
      }
    }
  }
  ${CategoryLevelPageBootcampFragmentDoc}
`;

/**
 * __useCategoryLevelPageSearchBootcampsQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageSearchBootcampsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageSearchBootcampsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageSearchBootcampsQuery({
 *   variables: {
 *      categoriesFilter: // value for 'categoriesFilter'
 *      subCategoriesFilter: // value for 'subCategoriesFilter'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useCategoryLevelPageSearchBootcampsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CategoryLevelPageSearchBootcampsQuery,
    CategoryLevelPageSearchBootcampsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageSearchBootcampsQuery,
    CategoryLevelPageSearchBootcampsQueryVariables
  >(CategoryLevelPageSearchBootcampsDocument, options);
}
export function useCategoryLevelPageSearchBootcampsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageSearchBootcampsQuery,
    CategoryLevelPageSearchBootcampsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageSearchBootcampsQuery,
    CategoryLevelPageSearchBootcampsQueryVariables
  >(CategoryLevelPageSearchBootcampsDocument, options);
}
export function useCategoryLevelPageSearchBootcampsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageSearchBootcampsQuery,
        CategoryLevelPageSearchBootcampsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageSearchBootcampsQuery,
    CategoryLevelPageSearchBootcampsQueryVariables
  >(CategoryLevelPageSearchBootcampsDocument, options);
}
export type CategoryLevelPageSearchBootcampsQueryHookResult = ReturnType<
  typeof useCategoryLevelPageSearchBootcampsQuery
>;
export type CategoryLevelPageSearchBootcampsLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageSearchBootcampsLazyQuery
>;
export type CategoryLevelPageSearchBootcampsSuspenseQueryHookResult =
  ReturnType<typeof useCategoryLevelPageSearchBootcampsSuspenseQuery>;
export type CategoryLevelPageSearchBootcampsQueryResult = Apollo.QueryResult<
  CategoryLevelPageSearchBootcampsQuery,
  CategoryLevelPageSearchBootcampsQueryVariables
>;
export const CategoryLevelPageStaticLexDocument = gql`
  query CategoryLevelPage_StaticLex($slugs: [String!]!) {
    lexListBySlugs(slugs: $slugs) {
      isRamped
    }
  }
`;

/**
 * __useCategoryLevelPageStaticLexQuery__
 *
 * To run a query within a React component, call `useCategoryLevelPageStaticLexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryLevelPageStaticLexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryLevelPageStaticLexQuery({
 *   variables: {
 *      slugs: // value for 'slugs'
 *   },
 * });
 */
export function useCategoryLevelPageStaticLexQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoryLevelPageStaticLexQuery,
    CategoryLevelPageStaticLexQueryVariables
  > &
    (
      | { variables: CategoryLevelPageStaticLexQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CategoryLevelPageStaticLexQuery,
    CategoryLevelPageStaticLexQueryVariables
  >(CategoryLevelPageStaticLexDocument, options);
}
export function useCategoryLevelPageStaticLexLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryLevelPageStaticLexQuery,
    CategoryLevelPageStaticLexQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CategoryLevelPageStaticLexQuery,
    CategoryLevelPageStaticLexQueryVariables
  >(CategoryLevelPageStaticLexDocument, options);
}
export function useCategoryLevelPageStaticLexSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CategoryLevelPageStaticLexQuery,
        CategoryLevelPageStaticLexQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CategoryLevelPageStaticLexQuery,
    CategoryLevelPageStaticLexQueryVariables
  >(CategoryLevelPageStaticLexDocument, options);
}
export type CategoryLevelPageStaticLexQueryHookResult = ReturnType<
  typeof useCategoryLevelPageStaticLexQuery
>;
export type CategoryLevelPageStaticLexLazyQueryHookResult = ReturnType<
  typeof useCategoryLevelPageStaticLexLazyQuery
>;
export type CategoryLevelPageStaticLexSuspenseQueryHookResult = ReturnType<
  typeof useCategoryLevelPageStaticLexSuspenseQuery
>;
export type CategoryLevelPageStaticLexQueryResult = Apollo.QueryResult<
  CategoryLevelPageStaticLexQuery,
  CategoryLevelPageStaticLexQueryVariables
>;
